import _ from 'underscore';

export default class ProductGroupSpecs {
  constructor($scope, $rootScope, ProductService) {
    $scope.tabs = [
      {
        title: 'Groups with Specs',
        groups: []
      },
      {
        title: 'Groups without Specs',
        groups: []
      }
    ];

    $scope.set_selected_tab = function(index) {
      $scope.selected_tab = index;
    };

    function load_groups() {
      $scope.tabs[0].groups = [];
      $scope.tabs[1].groups = [];
      $scope.loading = true;
      ProductService.get_groups_with_specs().success(function(data) {
        _.each(data.groups, function(group) {
          var index = group.specs.length > 0 ? 0 : 1;
          $scope.tabs[index].groups.push(group);
        });
        $scope.loading = false;
      });
    }

    $scope.show_specs = function(group) {
      $rootScope.$broadcast('open_product_group_specs_dialog', {
        product_group_id: group.id
      });
    };

    $scope.$on('load_product_group_specs', function(/*event, args*/) {
      load_groups();
    });

    $scope.init = function() {
      $scope.selected_tab = 0;
      load_groups();
    };

    $scope.init();
  }
}

ProductGroupSpecs.$inject = ['$scope', '$rootScope', 'ProductService'];



// WEBPACK FOOTER //
// ./front/js/admin/controllers/product-group-specs.ctrl.js